import { fetchLoadGraphProjectResources, fetchLoadGraphProjectLoads } from "./getData";

const fetchData = async (projectId) => {
  console.log('data start to load');

  // Fetch resources.json
  const resourcesData = await fetchLoadGraphProjectResources(projectId);
  const resourceIds = resourcesData.Resources;
  const dates = resourcesData.Dates;

  // Extract table headers
  const tableHeaders = ["グループ", "資源コード", "工程", "勤務シフト"];
  const timeGroups = { day: {}, week: {}, month: {} };
  const data = [];

  // Format timeGroups 
  dates.forEach((date, index) => {
    const dateObj = new Date(date);
    const monthKey = dateObj.toLocaleDateString("ja-JP", { year: "numeric", month: "long" });

    // Initialize time groups and resource percentages only once per monthKey
    // auto finish the month part
    ["day", "week", "month"].forEach(period => {
      if (!timeGroups[period][monthKey]) {
        timeGroups[period][monthKey] = period === "month" ? [`${monthKey}`] : [];
      }
    });

    const options = { month:"numeric", day: "numeric", weekday: "short" };
    // day part
    /* let formattedDay = dateObj.toLocaleDateString("ja-JP", options).replace(/(.+)\((.+)\)/, "$1\n$2").replace("日", ""); */
    let formattedDay = dateObj.toLocaleDateString("ja-JP", options).replace(/\((.*?)\)/, "\n$1");
    if (!timeGroups.day[monthKey].includes(formattedDay)) {
      timeGroups.day[monthKey].push(formattedDay);
    }
    // week part
    if (dateObj.getDay() === 0 || index === dates.length - 1) {
      const weekKey = getWeekKey(dateObj, dates[0]);
      timeGroups.week[monthKey].push(weekKey);
    }
  });

  // Fetch all resource data concurrently
  const resourceDataPromises = resourceIds.map(resourceId => fetchLoadGraphProjectLoads(projectId, resourceId));
  const resourcesDataList = await Promise.all(resourceDataPromises);

  // Process each resource after fetching all data
  resourcesDataList.forEach((resourceData, resIndex) => {
    const resource = {
      resourceCode: resourceData.Res_Code,
      process: resourceData.Res_Name,
      group: resourceData.Res_Group,
      shift: resourceData.Shift,
      percentages: { day: {}, week: {}, month: {} },
    };

    let currentWeekSum = { num: 0, den: 0 };
    let currentMonthSum = { num: 0, den: 0 };
    let currentMonth = null;

    dates.forEach((date, index) => {
      const dateObj = new Date(date);
      const monthKey = dateObj.toLocaleDateString("ja-JP", { year: "numeric", month: "long" });

      // Initialize resource percentages only once per monthKey
      ["day", "week", "month"].forEach(period => {
        if (!resource.percentages[period][monthKey]) {
          resource.percentages[period][monthKey] = [];
        }
      });

      const loadArray = resourceData.Loads[index];
      const load = (loadArray[0] === -1 || loadArray[1] === -1) ? -1 : (loadArray[1] / loadArray[0]);
      resource.percentages.day[monthKey].push(load * 100);

      if (loadArray[0] !== -1 && loadArray[1] !== -1) {
        currentWeekSum.num += loadArray[1];
        currentWeekSum.den += loadArray[0];
        currentMonthSum.num += loadArray[1];
        currentMonthSum.den += loadArray[0];
      }

      if (dateObj.getDay() === 0 || index === dates.length - 1) {
        resource.percentages.week[monthKey].push((currentWeekSum.den ? currentWeekSum.num / currentWeekSum.den : 0) * 100);
        currentWeekSum = { num: 0, den: 0 };
      }

      if (currentMonth === null) {
        currentMonth = monthKey;
      }
      if (isLastDayOfMonth(dateObj) || index === dates.length - 1) {
        resource.percentages.month[currentMonth].push((currentMonthSum.den ? currentMonthSum.num / currentMonthSum.den : 0) * 100);
        currentMonthSum = { num: 0, den: 0 };
        currentMonth = null;
      }
    });

    data.push(resource);
  });

  const formattedTimeGroups = Object.keys(timeGroups).reduce((acc, period) => {
    acc[period] = Object.keys(timeGroups[period]).reduce((acc2, key) => {
      acc2[key] = timeGroups[period][key];
      return acc2;
    }, {});
    return acc;
  }, {});
  return { tableHeaders, timeGroups: formattedTimeGroups, data };
};

const getWeekKey = (dateObj, startDate) => {
  const startOfWeek = new Date(dateObj);
  const endOfWeek = new Date(dateObj);
  const day = dateObj.getDay();
  // Get the first day of the week
  startOfWeek.setDate(dateObj.getDate() + (day === 0 ? -6 : 1 - day));
  
  // Adjust the start of the week if it is before the start date
  // the end of the week if it is after the end date
  if (startOfWeek < new Date(startDate)) {
    startOfWeek.setTime(new Date(startDate).getTime());
  }

  const start = startOfWeek.toLocaleDateString("ja-JP", { month: "numeric", day: "numeric", weekday: "short" });
  const end = endOfWeek.toLocaleDateString("ja-JP", { month: "numeric", day: "numeric", weekday: "short" });

  return `${start} - ${end}`;
};

const isLastDayOfMonth = (date) => {
  const testDate = new Date(date);
  testDate.setDate(testDate.getDate() + 1);
  return testDate.getDate() === 1;
};

export default fetchData;
